export default {
      id: "rocket-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#rocket-usage",
      toString: function () {
        return this.url;
      }
    }